import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as Sentry from '@sentry/browser';
import { withRouter } from 'react-router-dom';
import { fetchPendingOrder, updatePendingOrder, getHalfHalf } from './actions';
import './index.css';
import {
  MENU_ORDER_STATUS,
  MENU_ORDER_TYPE,
  ORDER_PAYMENT_TYPE,
} from 'helpers/enums';
import getImage from 'helpers/getImage';

class ConfirmOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: 2,
      keyBoard: false,
      height: 474,
      goupedMenuItems: [],
      processingAccept: false,
      processingDeclined: false,
      updateOnce: true,
    };
  }

  componentDidMount() {
    const { storeConfig } = this.props;
    let data = this.props.location.pathname.split('/');
    if (data.length === 3) {
      this.props.fetchPendingOrderHandler(data[2]);
      this.props.getHalfHalfHandler(storeConfig.storeId);
    } else {
      this.props.fetchPendingOrderHandler(data[2]);
      this.props.history.replace('/');
    }
    this.computeBookingInfoHeight();
  }

  componentDidUpdate(prevProps) {
    const {
      order: { pendingOrder },
    } = this.props;
    if (
      pendingOrder &&
      prevProps.pendingOrder &&
      pendingOrder._id !== prevProps.pendingOrder._id
    ) {
      if (pendingOrder.orderStatus !== MENU_ORDER_STATUS.unconfirmed) {
        if (this.state.updateOnce === true) {
          this.setState({
            height: this.state.height + 47,
            updateOnce: false,
          });
        }
      }
      let groupedMenuItems = this.getGoupedMenuItems(pendingOrder);
      this.setState({ goupedMenuItems: groupedMenuItems });
    }
    if (this.props.order.isOrderUpdated !== prevProps.order.isOrderUpdated) {
      if (this.props.order.isOrderUpdated) {
        this.setState({
          processingAccept: false,
          processingDeclined: false,
        });
      }
    }
    window.navigator.userAgent.match(/android/i) &&
      window.addEventListener(
        'resize',
        this.onElementHeightChange.bind(this, window.innerHeight)
      );
  }

  componentWillUnmount() {
    window.navigator.userAgent.match(/android/i) &&
      window.removeEventListener(
        'resize',
        this.onElementHeightChange.bind(this)
      );

    document.getElementById('root').classList.remove('hideRootScroll');
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope((scope) => {
      Object.keys(errorInfo).forEach((key) => {
        scope.setExtra(key, errorInfo[key]);
      });
      Sentry.captureException(error);
    });
  }

  getGoupedMenuItems = (order) => {
    let items = [];
    if (order.menuItems) {
      order.menuItems.map((item) => {
        if (item.isHalf) {
          let betterHalfs = order.menuItems.filter((obj) => {
            return obj.halfIndex === item.halfIndex && obj._id !== item._id;
          });
          let xBetterHalf = items.filter((obj) => {
            return obj._idHalf === item._id;
          });
          if (
            betterHalfs &&
            betterHalfs.length > 0 &&
            xBetterHalf.length === 0
          ) {
            item.urlHalf = getImage(
              betterHalfs[0].mediaPath || betterHalfs[0].urlS3
            );
            item._idHalf = betterHalfs[0]._id;
            item.nameHalf = betterHalfs[0].name;
            item.itemTypeHalf = betterHalfs[0].itemType;
            item.baseModifierIdHalf = betterHalfs[0].baseModifierId;
            item.selectedSizesHalf = betterHalfs[0].selectedSizes;
            item.selectedModifiersHalf = betterHalfs[0].selectedModifiers;
            item.removedIngredientsHalf = betterHalfs[0].removedIngredients;
            item.selectedIngredientsHalf = betterHalfs[0].selectedIngredients;
            item.selectedExtraIngredientsHalf =
              betterHalfs[0].selectedExtraIngredients;
            items.push(item);
          }
        } else {
          items.push(item);
        }
        return item;
      });
      return items;
    }
  };

  getItemCustomizedPrice = (itemObj, sizeObj) => {
    const { halfHalfSetup } = this.props;
    let itemPrice = 0;
    let quantity = 0;
    let halfQuantity = 0;
    let extraPrice = 0;
    let extraPriceHalf = 0;
    let currentItem = JSON.parse(JSON.stringify(itemObj));
    if (!currentItem.itemType || currentItem.itemType === 0) {
      currentItem.selectedSizes &&
        currentItem.selectedSizes.map((item) => {
          if (item._id === sizeObj._id) {
            if (item.quantity > 0) {
              quantity = quantity + item.quantity;
              itemPrice = itemPrice + item.quantity * Number(item.price);
            }
            if (item.variants) {
              item.variants.map((v) => {
                if (v.quantity && Number(v.quantity) > 0)
                  itemPrice = itemPrice + item.quantity * Number(v.price);
                return v;
              });
            }
          }
          return item;
        });
      if (quantity > 0) {
        currentItem.selectedExtraIngredients &&
          currentItem.selectedExtraIngredients.map((item, index) => {
            if (item.quantity > 0) {
              extraPrice =
                extraPrice + Number(item.quantity) * Number(item.price);
            }
            return item;
          });
        itemPrice =
          extraPrice *
            (halfHalfSetup?.chargeFullHalfExtraPrice
              ? Math.max(quantity, 1)
              : quantity) +
          itemPrice;
      }
    } else {
      currentItem.selectedModifiers &&
        currentItem.selectedModifiers.map((m) => {
          m.subModifiers.map((s) => {
            if (m._id === currentItem.baseModifierId) {
              quantity = s.quantity;
              itemPrice = itemPrice + Number(s.quantity) * Number(s.price);
              if (s.variants) {
                s.variants.map((v) => {
                  itemPrice = itemPrice + Number(v.quantity) * Number(v.price);
                  return v;
                });
              }
            } else {
              if (s.prices) {
                s.prices.map((p) => {
                  itemPrice = itemPrice + Number(p.quantity) * Number(p.price);
                  if (p.variants) {
                    p.variants.map((v) => {
                      itemPrice =
                        itemPrice + Number(v.quantity) * Number(v.price);
                      return v;
                    });
                  }
                  return p;
                });
              }
            }
            return s;
          });
          return m;
        });
      if (quantity > 0) {
        currentItem.selectedExtraIngredients &&
          currentItem.selectedExtraIngredients.map((item) => {
            if (item.quantity > 0) {
              extraPrice =
                extraPrice + Number(item.quantity) * Number(item.price);
            }
            return item;
          });
        itemPrice =
          extraPrice *
            (halfHalfSetup?.chargeFullHalfExtraPrice
              ? Math.max(quantity, 1)
              : quantity) +
          itemPrice;
      }
    }
    if (
      currentItem.isHalf &&
      (!currentItem.itemTypeHalf || currentItem.itemTypeHalf === 0)
    ) {
      currentItem.selectedSizesHalf &&
        currentItem.selectedSizesHalf.map((item) => {
          if (item.quantity > 0) {
            halfQuantity = halfQuantity + item.quantity;
            itemPrice = itemPrice + item.quantity * Number(item.price);
          }
          if (item.variants) {
            item.variants.map((v) => {
              if (v.quantity && Number(v.quantity) > 0)
                itemPrice = itemPrice + item.quantity * Number(v.price);
              return v;
            });
          }
          return item;
        });
      if (halfQuantity > 0) {
        currentItem.selectedExtraIngredientsHalf &&
          currentItem.selectedExtraIngredientsHalf.map((item) => {
            if (item.quantity > 0) {
              extraPriceHalf = extraPriceHalf + item.quantity * item.price;
            }
            return item;
          });
        itemPrice = extraPriceHalf * halfQuantity + itemPrice;
      }
    } else if (currentItem.isHalf && currentItem.itemTypeHalf === 1) {
      currentItem.selectedModifiersHalf &&
        currentItem.selectedModifiersHalf.map((m) => {
          m.subModifiers.map((s) => {
            if (m._id === currentItem.baseModifierIdHalf) {
              halfQuantity = s.quantity;
              itemPrice = itemPrice + Number(s.quantity) * Number(s.price);
              if (s.variants) {
                s.variants.map((v) => {
                  itemPrice = itemPrice + Number(v.quantity) * Number(v.price);
                  return v;
                });
              }
            } else {
              if (s.prices) {
                s.prices.map((p) => {
                  itemPrice = itemPrice + Number(p.quantity) * Number(p.price);
                  if (p.variants) {
                    p.variants.map((v) => {
                      itemPrice =
                        itemPrice + Number(v.quantity) * Number(v.price);
                      return v;
                    });
                  }
                  return p;
                });
              }
            }
            return s;
          });
          return m;
        });
      if (halfQuantity > 0) {
        currentItem.selectedExtraIngredientsHalf &&
          currentItem.selectedExtraIngredientsHalf.map((item) => {
            if (item.quantity > 0) {
              extraPriceHalf = extraPriceHalf + item.quantity * item.price;
            }
            return item;
          });
        itemPrice = extraPriceHalf * halfQuantity + itemPrice;
      }
    }
    if (currentItem.isHalf)
      itemPrice =
        itemPrice +
        (this.props.halfHalfSetup
          ? Number(this.props.halfHalfSetup.halfHalfAdditionalCharges)
          : 0) *
          (quantity + halfQuantity);
    return itemPrice.toFixed(2);
  };

  getItemCustomizedPriceOnly = (itemObj, sizeObj) => {
    let itemPrice = 0;
    let quantity = 0;
    let halfQuantity = 0;
    let currentItem = JSON.parse(JSON.stringify(itemObj));
    if (!currentItem.itemType || currentItem.itemType === 0) {
      currentItem.selectedSizes &&
        currentItem.selectedSizes.map((item) => {
          if (item._id === sizeObj._id) {
            if (item.quantity > 0) {
              quantity = quantity + item.quantity;
              itemPrice = itemPrice + item.quantity * Number(item.price);
            }
            if (item.variants) {
              item.variants.map((v) => {
                if (v.quantity && Number(v.quantity) > 0)
                  itemPrice = itemPrice + item.quantity * Number(v.price);
                return v;
              });
            }
          }
          return item;
        });
    } else {
      currentItem.selectedModifiers &&
        currentItem.selectedModifiers.map((m) => {
          m.subModifiers.map((s) => {
            if (m._id === currentItem.baseModifierId) {
              quantity = s.quantity;
              itemPrice = itemPrice + Number(s.quantity) * Number(s.price);
              if (s.variants) {
                s.variants.map((v) => {
                  itemPrice = itemPrice + Number(v.quantity) * Number(v.price);
                  return v;
                });
              }
            } else {
              if (s.prices) {
                s.prices.map((p) => {
                  itemPrice = itemPrice + Number(p.quantity) * Number(p.price);
                  if (p.variants) {
                    p.variants.map((v) => {
                      itemPrice =
                        itemPrice + Number(v.quantity) * Number(v.price);
                      return v;
                    });
                  }
                  return p;
                });
              }
            }
            return s;
          });
          return m;
        });
    }
    if (
      currentItem.isHalf &&
      (!currentItem.itemTypeHalf || currentItem.itemTypeHalf === 0)
    ) {
      currentItem.selectedSizesHalf &&
        currentItem.selectedSizesHalf.map((item) => {
          if (item.quantity > 0) {
            halfQuantity = halfQuantity + item.quantity;
            itemPrice = itemPrice + item.quantity * Number(item.price);
          }
          if (item.variants) {
            item.variants.map((v) => {
              if (v.quantity && Number(v.quantity) > 0)
                itemPrice = itemPrice + item.quantity * Number(v.price);
              return v;
            });
          }
          return item;
        });
    } else if (currentItem.isHalf && currentItem.itemTypeHalf === 1) {
      currentItem.selectedModifiersHalf &&
        currentItem.selectedModifiersHalf.map((m) => {
          m.subModifiers.map((s) => {
            if (m._id === currentItem.baseModifierIdHalf) {
              halfQuantity = s.quantity;
              itemPrice = itemPrice + Number(s.quantity) * Number(s.price);
              if (s.variants) {
                s.variants.map((v) => {
                  itemPrice = itemPrice + Number(v.quantity) * Number(v.price);
                  return v;
                });
              }
            } else {
              if (s.prices) {
                s.prices.map((p) => {
                  itemPrice = itemPrice + Number(p.quantity) * Number(p.price);
                  if (p.variants) {
                    p.variants.map((v) => {
                      itemPrice =
                        itemPrice + Number(v.quantity) * Number(v.price);
                      return v;
                    });
                  }
                  return p;
                });
              }
            }
            return s;
          });
          return m;
        });
    }
    if (currentItem.isHalf)
      itemPrice =
        itemPrice +
        (this.props.halfHalfSetup
          ? Number(this.props.halfHalfSetup.halfHalfAdditionalCharges)
          : 0) *
          (quantity + halfQuantity);
    return itemPrice.toFixed(2);
  };

  computeBookingInfoHeight = () => {
    let interim = 0;
    if (document.querySelector('#root')) {
      if (document.querySelector('#root').offsetHeight !== undefined) {
        interim = document.querySelector('#root').offsetHeight;
      }
    }
    if (document.querySelector('.detailsTitle')) {
      if (document.querySelector('.detailsTitle').offsetHeight !== undefined) {
        interim =
          interim - document.querySelector('.detailsTitle').offsetHeight;
      }
    }
    if (
      document.querySelector(
        '.visible-xs.visible-sm.addressMobileBar.shadowMobileBar'
      )
    ) {
      if (
        document.querySelector(
          '.visible-xs.visible-sm.addressMobileBar.shadowMobileBar'
        ).offsetHeight !== undefined
      ) {
        interim =
          interim -
          document.querySelector(
            '.visible-xs.visible-sm.addressMobileBar.shadowMobileBar'
          ).offsetHeight;
      }
    }
    interim = interim - 154 * 2;
    this.setState({
      height: interim,
    });
  };

  onElementHeightChange = (height) => {
    let lastHeight = height;
    let newHeight = window.innerHeight;
    if (lastHeight - newHeight > 125) {
      this.setState({ keyBoard: true });
    } else {
      if (this.state.keyBoard === true && lastHeight - newHeight === 0) {
        this.setState({ keyBoard: false });
      }
    }
  };

  updateOrder = (status) => {
    const {
      order: { pendingOrder },
    } = this.props;
    if (
      !(this.state.processingAccept && this.state.processingDeclined) &&
      pendingOrder &&
      pendingOrder.orderStatus === MENU_ORDER_STATUS.unconfirmed
    ) {
      this.setState(
        (prevState) => {
          return {
            processingAccept: status !== '11' ? true : false,
            processingDeclined: status === '11' ? true : false,
            isOrderUpdated: false,
            //height: prevState.height + 47,
          };
        },
        () => {
          this.props.updateOrderHandler(pendingOrder, status);
        }
      );
    }
  };

  rootOverflowRestrict = () => {
    document.getElementById('root').classList.add('hideRootScroll');
  };

  render() {
    const {
      storeConfig,
      order: { pendingOrder },
    } = this.props;
    return (
      <div
        className={
          this.state.keyBoard
            ? `reviewsStar col-xs-12 keyB row${this.state.rows}`
            : 'reviewsStar col-xs-12'
        }
      >
        {this.rootOverflowRestrict()}
        <div className='detailsTitle'>
          {Object.keys(pendingOrder).length !== 0 &&
          pendingOrder.constructor === Object &&
          pendingOrder.orderStatus === MENU_ORDER_STATUS.unconfirmed
            ? 'Awaiting Confirmation'
            : pendingOrder.orderStatus === MENU_ORDER_STATUS.cancelled
            ? 'Declined Order'
            : pendingOrder.orderStatus === MENU_ORDER_STATUS.delivered ||
              pendingOrder.orderStatus === MENU_ORDER_STATUS.placed ||
              pendingOrder.orderStatus === MENU_ORDER_STATUS.in_kitchen ||
              pendingOrder.orderStatus === MENU_ORDER_STATUS.on_the_way ||
              pendingOrder.orderStatus === MENU_ORDER_STATUS.out_for_delivery
            ? 'Confirmed Order'
            : null}
        </div>
        <div className='visible-xs visible-sm addressMobileBar shadowMobileBar'>
          <div
            className={`addB2 pick`}
            onClick={this.openTimeBar}
            style={{ color: '#4b4a4a', borderBottom: '1px solid #dbdbdb' }}
          >
            <i className='icon-Clock' />
            {storeConfig.name}
          </div>
          <div className='addB1' style={{ color: '#8e8e8e' }}>
            <i className='icon-Location-Pin' />
            {storeConfig.address}
          </div>
        </div>
        <div
          className='resCat marginTop handle-overflow'
          style={{ height: this.state.height, marginTop: '1rem' }}
        >
          {pendingOrder &&
          pendingOrder.firstName &&
          pendingOrder.firstName !== '' ? (
            <div>
              <div className='alignConfirmInfo bookingContent'>
                <div className='bookingLabel'>Name</div>
                <div className='bookingValue'>
                  {`${pendingOrder.firstName} 
                  ${pendingOrder.lastName}`}
                </div>
              </div>
            </div>
          ) : (
            <div />
          )}
          {pendingOrder &&
          pendingOrder.mobileNumber &&
          pendingOrder.mobileNumber !== '' ? (
            <div>
              <div className='alignConfirmInfo bookingContent'>
                <div className='bookingLabel'>Mobile Number</div>
                <div className='bookingValue'>{pendingOrder.mobileNumber}</div>
              </div>
            </div>
          ) : (
            <div />
          )}
          {pendingOrder &&
          pendingOrder.address &&
          pendingOrder.orderType === MENU_ORDER_TYPE.delivery ? (
            <div>
              <div className='alignConfirmInfo bookingContent'>
                <div className='bookingLabel'>Address</div>
                <div className='bookingValue' style={{ textAlign: 'right' }}>
                  {pendingOrder.address}
                </div>
              </div>
            </div>
          ) : (
            <div />
          )}
          {pendingOrder && pendingOrder.orderType ? (
            <div>
              <div className='alignConfirmInfo bookingContent'>
                <div>
                  <div className='bookingLabel'>Order Type</div>
                </div>
                <div className='bookingValue'>
                  {pendingOrder.orderType === MENU_ORDER_TYPE.pickup &&
                    'Pickup'}
                  {pendingOrder.orderType === MENU_ORDER_TYPE.delivery &&
                    'Delivery'}
                  {pendingOrder.orderType === MENU_ORDER_TYPE.dinein &&
                    'Dine-in'}
                </div>
              </div>
            </div>
          ) : (
            <div />
          )}
          {pendingOrder && pendingOrder.date ? (
            <div>
              <div className='alignConfirmInfo bookingContent'>
                <div>
                  <div className='bookingLabel'>Order Time</div>
                </div>
                <div className='bookingValue'>{pendingOrder.date}</div>
              </div>
            </div>
          ) : (
            <div />
          )}
          {pendingOrder && pendingOrder.deliveryDate ? (
            <div>
              <div className='alignConfirmInfo bookingContent'>
                <div>
                  <div className='bookingLabel'>Expected Time</div>
                </div>
                <div className='bookingValue'>{pendingOrder.deliveryDate}</div>
              </div>
            </div>
          ) : (
            <div />
          )}
          {pendingOrder && pendingOrder.paymentType ? (
            <div>
              <div className='alignConfirmInfo bookingContent'>
                <div>
                  <div className='bookingLabel'>Payment Type</div>
                </div>
                <div className='bookingValue'>
                  {pendingOrder.paymentType === ORDER_PAYMENT_TYPE.cash
                    ? 'Cash'
                    : 'Card'}
                </div>
              </div>
            </div>
          ) : (
            <div />
          )}
          {pendingOrder && pendingOrder.payableAmount ? (
            <div>
              <div className='alignConfirmInfo bookingContent'>
                <div>
                  <div className='bookingLabel'>Payment Amount</div>
                </div>
                <div className='bookingValue'>
                  {`${storeConfig.currency}${pendingOrder.payableAmount}`}
                </div>
              </div>
            </div>
          ) : (
            <div />
          )}
          {pendingOrder.specials && pendingOrder.specials.length !== 0 && (
            <div className='bookingContent'>
              <p style={{ fontSize: '2.5rem', fontWeight: 400 }}>Specials</p>
            </div>
          )}
          {pendingOrder.specials &&
            pendingOrder.specials.map((m, index) => (
              <div key={index} className='alignConfirmInfo bookingContent'>
                <span className='extaWidth lightFont'>{m.name}</span>
                <span
                  className='IngPrice'
                  style={{ paddingTop: 0, paddingRight: 0 }}
                >{`-${storeConfig.currency}${m.discount}`}</span>
              </div>
            ))}

          {pendingOrder &&
            pendingOrder.orderType !== MENU_ORDER_TYPE.pickup && (
              <React.Fragment>
                <div className='bookingContent'>
                  <p style={{ fontSize: '2.5rem', fontWeight: 400 }}>
                    Additional Charges
                  </p>
                </div>
                <div className='alignConfirmInfo bookingContent'>
                  <span className='extraWidth lightFont'>Delivery Fee</span>
                  <span
                    className='IngPrice'
                    style={{ paddingTop: 0, paddingRight: 0 }}
                  >{`${storeConfig.currency}${pendingOrder.deliveryCost}`}</span>
                </div>
              </React.Fragment>
            )}
          {pendingOrder && pendingOrder.notes !== '' && (
            <React.Fragment>
              <div className='bookingContent'>
                <p style={{ fontSize: '2.5rem', fontWeight: 400 }}>
                  Delivery Notes
                </p>
              </div>
              <div className='alignConfirmInfo bookingContent'>
                <span className='extraWidth lightFont'>Delivery Fee</span>
                <span
                  className='IngPrice'
                  style={{ paddingTop: 0, paddingRight: 0 }}
                >{`${pendingOrder.notes}`}</span>
              </div>
            </React.Fragment>
          )}
          {pendingOrder && pendingOrder.voucherId !== '' && (
            <React.Fragment>
              <div className='bookingContent'>
                <p style={{ fontSize: '2.5rem', fontWeight: 400 }}>
                  Voucher Code
                </p>
              </div>
              <div className='alignConfirmInfo bookingContent'>
                <span className='extraWidth lightFont'>
                  {pendingOrder.voucherName}
                </span>
                <span
                  className='IngPrice'
                  style={{ paddingTop: 0, paddingRight: 0 }}
                >
                  {`-${storeConfig.currency}${pendingOrder.voucherDiscount}`}
                </span>
              </div>
            </React.Fragment>
          )}
        </div>
        {pendingOrder.orderStatus === MENU_ORDER_STATUS.unconfirmed && (
          <div
            className={`reviewBarM align-confirmation-buttons ${
              pendingOrder &&
              pendingOrder.orderStatus === MENU_ORDER_STATUS.unconfirmed
                ? ''
                : 'disable-action-buttons'
            }`}
          >
            {this.state.processingAccept ? (
              <div className='comM notesM approve-action'>
                <img
                  height='16px'
                  src={`${window.storeConfigInitial?.storageBaseUrl}/assets/next-loading.svg`}
                  alt=''
                />
              </div>
            ) : (
              <div
                className='comM notesM approve-action'
                onClick={() => {
                  pendingOrder.orderType === MENU_ORDER_TYPE.delivery
                    ? this.updateOrder('2')
                    : this.updateOrder('1');
                }}
              >
                Accept
              </div>
            )}
            {this.state.processingDeclined ? (
              <span className='comM notesM decline-action'>
                <img
                  height='25px'
                  src={`${window.storeConfigInitial?.storageBaseUrl}/assets/next-loading.svg`}
                  alt=''
                />
              </span>
            ) : (
              <div
                className='comM timeRM decline-action'
                onClick={() => this.updateOrder('11')}
              >
                Decline
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    order: state.pendingOrderReducer,
    storeConfig: state.layoutReducer.storeConfig,
    halfHalfSetup: state.layoutReducer.halfHalfSetup,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchPendingOrderHandler: (pendingOrderId) =>
      dispatch(fetchPendingOrder(pendingOrderId)),
    updateOrderHandler: (order, status) =>
      dispatch(updatePendingOrder(order, status)),
    getHalfHalfHandler: (storeId) => dispatch(getHalfHalf(storeId)),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ConfirmOrder));
